/* RANI CUSTOM — Loox tooltip "Daha fazlasını öğren" linkini DOM'dan kaldır (talep)
   Loox info tooltip'i kalır (verified review açıklaması), sadece uzun modal'a giden link kaldırılır.
   Hem ana DOM hem de iç shadow DOM'lar (varsa) taranır. */
(function () {
  if (typeof window === 'undefined') return;

  // Loox link kesin selector'ları
  var KILL_SELECTORS = [
    '.verified-notification-learn-more-trigger',
    '[data-verify-reviews-popup]',
    '[data-testid="qv-review-verified-notification-learn-more-button"]'
  ].join(',');

  function killInRoot(root) {
    if (!root || !root.querySelectorAll) return;
    try {
      var found = root.querySelectorAll(KILL_SELECTORS);
      if (found.length > 0) {
        console.log('[RANI LOOX] killing', found.length, 'links');
      }
      found.forEach(function (el) {
        // Önce inline style ile gizle (görsel olarak anında kaybolur)
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        // Sonra DOM'dan kaldır
        if (el.parentNode) {
          try { el.parentNode.removeChild(el); } catch (e) {}
        }
      });
    } catch (e) { console.warn('[RANI LOOX] error:', e); }
    // Shadow DOM'ları da tara
    if (root.querySelectorAll) {
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        if (all[i].shadowRoot) killInRoot(all[i].shadowRoot);
      }
    }
  }

  function killAll() {
    killInRoot(document);
  }

  // İlk çalıştırma
  killAll();

  // MutationObserver — her DOM ekleme sonrası tara
  var observer = new MutationObserver(function (mutations) {
    var dirty = false;
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes && mutations[i].addedNodes.length > 0) {
        dirty = true;
        break;
      }
    }
    if (dirty) killAll();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Loox info butonuna tıklama sonrası tooltip render ediliyor — click event'te de tekrar tara
  document.addEventListener('click', function (e) {
    var trg = e.target;
    if (!trg) return;
    // Loox info icon tıklaması veya yorum bölgesinde tıklama
    setTimeout(killAll, 10);
    setTimeout(killAll, 100);
    setTimeout(killAll, 300);
  }, true); // capture phase, herşeyden önce
})();
